import { useEffect, useState } from "react";

/**
 * Live `matchMedia` as a boolean.
 *
 * For layout that CSS alone can't express — a table whose `colSpan` has to
 * equal the number of columns actually rendered, when some of those columns
 * are dropped at a breakpoint. A colSpan larger than the table's column count
 * doesn't clamp: it *adds* a phantom column, and the widths all shift.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
